import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MojoCardModule } from 'mojo-card';

import { MatchesPhasesComponent } from '@shared/matches-phases/matches-phases.component';
import { NumberPresenterV2Module } from '@shared/number-presenter-v2/number-presenter-v2.module';
import { CarouselModule } from 'primeng/carousel';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';

const containers = [MatchesPhasesComponent];
@NgModule({
  imports: [
    MatIconModule,
    MatTabsModule,
    CarouselModule,
    MojoCardModule,
    CommonModule,
    NumberPresenterV2Module,
    RouterModule,
  ],
  exports: [...containers],
  declarations: [...containers],
})
export class MatchesPhasesModule {}
